import { render, staticRenderFns } from "./IntroductionVideo.vue?vue&type=template&id=54b4f13b&scoped=true&lang=pug&"
import script from "./IntroductionVideo.vue?vue&type=script&lang=ts&"
export * from "./IntroductionVideo.vue?vue&type=script&lang=ts&"
import style0 from "./IntroductionVideo.vue?vue&type=style&index=0&id=54b4f13b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4f13b",
  null
  
)

export default component.exports